import axios from "axios";

const apiChangePasswordUrl = "/api/v1/users/reset";

export const handleApiChangePassword = async ({ changePasswordIn }) => {
  console.log("In handleAPIChangePassword");
  console.log("changePasswordIn is ", changePasswordIn);
  console.log("apiChangePasswordUrl is ", apiChangePasswordUrl);
  try {
    const res = await axios.patch(apiChangePasswordUrl, changePasswordIn, {
      headers: { "Content-Type": "application/json" },
    });
    console.log("res is ", res);
    return res.data.data;
  } catch (err) {
    console.log("An error occurred ", err);
    return "failed";
  }
};
